import Android from "@assets/icons/android.svg";
import Telegram from "@assets/icons/telegram.svg";
import Logo from "@assets/img/logo.svg";
import { NavigationButton } from "@components/navigation-button";
import { DOWNLOAD_CHECKER_LINK, TG_SUPPORT } from "@constants";
import classNames from "classnames";
import styles from "./menu.module.scss";
import { useAuth } from "@features/auth";

export type MenuConfig = { name: string; link: string; icon?: JSX.Element }[];

type Props = { config: MenuConfig };

export const Menu = ({ config }: Props) => {
  const { isTrader } = useAuth();
  return (
    <nav className={styles.menu}>
      <Logo className={styles.logo} />
      <ul>
        {config.map((item) => (
          <NavigationButton key={item.link} text={item.name} link={item.link}>
            {item.icon}
          </NavigationButton>
        ))}
      </ul>
      <div className={styles.bottom}>
        {isTrader && (
          <a
            className={classNames(styles.icon, styles.android)}
            href={DOWNLOAD_CHECKER_LINK}
            download="checker.apk"
          >
            <Android />
          </a>
        )}
        <a
          className={styles.icon}
          href={`https://t.me/${TG_SUPPORT}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Telegram />
        </a>
      </div>
    </nav>
  );
};
